import envVar from '../config/envVars';
import httpGet from './httpClient/httpGet';
import httpPost from './httpClient/httpPost';

// Shares an already-generated report card PDF with the student's family as an ecole post.

const sendReportCardToParent = async (
  studentId: string,
  reportCardUrl: string,
  academicYear: string,
  fileName?: string,
  termNames?: string[]
): Promise<any> => {
  const url = `${envVar.REACT_APP_BASE_API_URL}/posts/report-card`;
  return httpPost(url, {
    studentId,
    reportCardUrl,
    academicYear,
    fileName,
    termNames
  });
};


// "Sent"/"Resend" when the page is opened again - including in a later session.
const getReportCardDispatches = async (
  academicYear: string,
  grade: string,
  division: string
): Promise<any> => {
  const url = `${envVar.REACT_APP_BASE_API_URL}/posts/report-card/dispatches?academicYear=${academicYear}&grade=${grade}&division=${division}`;
  return httpGet(url);
};

const postsApis = {
  sendReportCardToParent,
  getReportCardDispatches
};

export default postsApis;
